// 微信openid相关api

import axios from '../utils//fetch';
import utils from '../tool';
import config from '../config';
import tool from '@tool';

/**
 * 绑定手机号
 * @param {*} options
 */
export const noHideInfoByOpenId = (options) => {
  const url = '/api/zmbiz-teacher-h5-api/weChatBind/noHideInfoByOpenId';
  return axios.postSign(url, options);
};

/**
 * 绑定手机号
 * @param {*} options
 */
export const bindMobile = (options) => {
  const url = '/api/zmbiz-teacher-h5-api/weChatBind/bindMobile';
  return axios.postSign(url, options);
};
export const bindMobileAutoJump = (options) => {
  const url = '/api/zmbiz-teacher-h5-api/weChatBind/bindMobileAutoJump';
  return axios.postSign(url, options);
};
export const codeAndRedirect = (options) => {
  const url = process.env.VUE_APP_API_ADMIN_H5TAWAY
    ? `${process.env.VUE_APP_API_ADMIN_H5TAWAY }/weChatPage/codeAndRedirect/${options.code}`
    : `/weChatPage/codeAndRedirect/${options.code}`;
  return axios.getSign(url);
};
/**
 * 解绑手机号
 * @param {*} options
 */
export const unbindMobile = (options) => {
  const url = '/api/zmbiz-teacher-h5-api/weChatBind/unbindMobile';
  return axios.postSign(url, options);
};

/**
 * 判断手机号是否已经绑定指定微信平台
 * @param {*} options
 */
export const isBindByMobile = (options) => {
  const url = '/api/zmbiz-teacher-h5-api/weChatBind/isBindByMobile';
  return axios.postSign(url, options);
};

/**
 * 根据openid获取教师id
 */
export function getTeaIdByOpenId(options) {
  if (utils.isEmpty(options)) {
    return Promise.reject('options missed');
  }

  if (utils.isEmpty(options.openId)) {
    return Promise.reject('openId missed');
  }

  const url = '/api/zmbiz-teacher-h5-api/weChatBind/getTeaIdByOpenId';
  return axios.post(url, options);
}

/**
 * 获取 可以获得openid的接口地址
 */
export function getOpenIdUrl() {
  return '/api/zmbiz-teacher-h5-api/weChatPage/getOtherCodeAndredirect';
}

/**
 * 根据微信的appid获取timeType
 */
export function getTimeType(wechatId) {
  if (!wechatId) {
    return '';
  }

  // 招聘圈
  if (wechatId == config.wechatId.recruitmentCircle) {
    return 1;
  }

  // 讲师平台
  if (wechatId == config.wechatId.lecturerPlatform) {
    return 0;
  }

  return '';
}

/**
 * 根据微信的appid获取对应公众号的名称
 */
export function getWechatName(wechatId) {
  if (!wechatId) {
    return '';
  }

  // 招聘圈
  if (wechatId == config.wechatId.recruitmentCircle) {
    return config.wechatName.recruitmentCircle;
  }

  // 讲师平台
  if (wechatId == config.wechatId.lecturerPlatform) {
    return config.wechatName.lecturerPlatform;
  }

  return '';
}

/**
 * 根据openid获取绑定信息
 */
export function infoByOpenIdNew(options) {
  // return Promise.resolve({
  //   userId: 'zl9ibNj76mRpE1SNU6I9Jog',
  //   mobile: '13162175913',
  // });
  const url = '/api/zmbiz-teacher-h5-api/weChatBind/infoByOpenIdNew';
  return axios.postSign(url, options);
}

/**
 * 根据timeType获取微信的appid
 */
export function getAppidByTimeType(timeType) {
  if (service.TimeType.isFullTimeType(timeType)) {
    return config.wechatId.recruitmentCircle;
  }

  if (service.TimeType.isPartTimeType(timeType)) {
    return config.wechatId.lecturerPlatform;
  }

  return '';
}

/**
 * 获取所有微信的appid
 */
export function getAllAppid() {
  return config.wechatId;
}

/**
 * 获取微信签名数据
 */
export function getWxConfigData() {
  const appid = getAppidByTimeType(_getTimeType());

  if (!appid) {
    return Promise.reject('appid lossed');
  }

  let __url = null;
  if (service.Environment.isIos()) {
    __url = service.HomePageAddress.get();
    console.log('是苹果手机');
  }

  const parm = {
    appid,
    url: __url || window.location.href,
  };

  return new Promise((resolve, reject) => {
    axios.post('/api/zmbiz-teacher-h5-api/common/getJsSignDto', parm).then(data => {
      if (data) {
        data.appid = parm.appid;
        data.url = parm.url;
        resolve(data);
      } else {
        reject('获取微信签名失败');
      }
    }).catch(message => {
      reject(message);
    });
  });
}

/**
 * 获取timeTpe
 */
function _getTimeType() {
  const query = new service.QueryUrl().parm;

  // 先从url上查找是否存在timeType参数
  let _timeType = query.timeType;
  if (tool.isEmpty(_timeType) == false) {
    return _timeType;
  }

  // 在从本地缓存查找是否保存了 timeType变量
  _timeType = sessionStorage.getItem('zm-time-type');
  if (tool.isEmpty(_timeType) == false) {
    return _timeType;
  }

  // 默认返回全职
  return 1;
}

/**
 * 绑定手机号
 * @param {*} options
 */
export const getQRCode = (options) => {
  const url = '/api/zmbiz-teacher-h5-api/weChatBind/getQRCode';
  return axios.postSign(url, options);
};